// DangerPopupWindow.js

import { Box, Text, Button, Layer, Image, Header, grommet, Grommet  } from "grommet";
import { useEffect, useRef } from "react";
import { Halt } from "grommet-icons";
import { deepMerge } from "grommet/utils";
import useTrapFocus from "../Utils/useTrapFocus";

  
const customTheme = deepMerge(grommet, {
    global: {
      colors: {
        brand: "#801204",
        text: "#801204",
        border: "#801204",
        selected: "light-4",
      },    
    },

  });

const DangerPopupWindow = (props) => {

    // Ref for the modal and focus trap to keep focus within it  
    const modalRef = useRef(null);
    useTrapFocus(modalRef, true); // Trap focus inside the modal while it's open

    return (
        <Grommet theme={customTheme} > 
            <Layer
                id="danger-msg"
                ref={modalRef}
                tabIndex="-1"
                position="center"
                style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dim background for modal effect
                }}              
                onEsc={props.onClose}
                onClickOutside={() => {}}
            >
                <Box 
                    overflow='auto'
                    pad="small" 
                    gap="small" 
                    width="medium"  
                    background="white"  
                    
                    style={{
                        position: 'relative',
                        margin: 'auto', // Center horizontally and vertically
                    }}
                >                
                <Box
                    pad="small" // Padding to create space for the white border
                    background="#FEF2E8" // White border
                    border={{ color: "brand"}}
                    >
                <Box style={{position:"relative"}}>
                    <Header margin="none" background="#fa8e7f" pad="small" height="xxsmall" justify="around">
                        <Text alignSelf="start" size="large"  align="center" >
                            <strong>Danger</strong>
                        </Text>
                    </Header>
                    <Box height="xsmall" width="xsmall"  
                        style={{position:"absolute", right: "3%", top: "15px"}}
                        right="0px"
                        >
                            <Image
                                size="contain"
                                src="Grape.png"                                  
                            />
                    </Box>                 
                </Box>

                <Box align="center" margin={{top: 'medium'}}>
                    <Halt color="brand" size='xlarge'/>
                    <Text  margin="large" textAlign="center" ><span style={{whiteSpace: 'pre-line', fontSize: '24px'}}><strong>{props.msg}</strong></span></Text>
                </Box> 
                <Box  align="center" margin={{top: "-20px"}}>
                    <Image
                        style={{
                          width: "200px",
                          height: "200px",
                          objectFit: "contain",
                        }}
                        src= {props.imgSrc ? props.imgSrc : "Mole.png"}                                  
                    />
                </Box>                                 
                <Box
                  as="footer"
                  gap="small"
                  direction="row"
                  align="center"
                  justify="center"
                  pad={{ top: 'medium', bottom: 'small' }}
                >
                  <Button
                    label={
                      <Text color="white">
                        <strong>Yes</strong>
                      </Text>
                    }
                    onClick={props.onConfirm}
                    primary
                   
                  />
                  <Button
                    label={
                      <Text >
                        <strong>No</strong>
                      </Text>
                    }
                    onClick={props.onClose}
                    secondary                   
                  />                                 
                </Box>
                </Box>
              </Box>
            </Layer>
        </Grommet> 
    )
}

export default DangerPopupWindow;
